<template>
    <div
        :class="{ active: show }"
        class="nibnut-send-message-button d-inline-block"
        @click.prevent.stop
    >
        <default-button
            :flavor="flavor"
            :size="size"
            :color="color"
            :label="label"
            :block="block"
            @click.prevent.stop="show = true"
        >
            <send-horizontal-icon />
        </default-button>
        <send-message-dialog
            :show.sync="show"
            :user-email="userEmail"
        />
    </div>
</template>

<script>
import DefaultButton from "@/nibnut/components/Buttons/DefaultButton"
import SendHorizontalIcon from "@/nibnut/icons/SendHorizontalIcon"

export default {
    name: "SendMessageButton",
    components: {
        DefaultButton,
        SendMessageDialog: () => import("@/custom/dialogs/SendMessageDialog"),
        SendHorizontalIcon
    },
    props: {
        label: {
            type: String,
            required: true
        },
        flavor: {
            type: String,
            validator: prop => !prop || prop.match(/^(link|normal)$/i),
            default: "normal"
        },
        size: {
            type: String,
            validator: prop => !prop || prop.match(/^(xs|sm|md|lg)$/i),
            default: "md"
        },
        color: {
            type: String,
            validator: prop => !prop || prop.match(/^(primary|secondary|regular|error|warning|success|clear|light|green)$/i),
            default: "regular"
        },
        block: {
            type: Boolean,
            default: false
        },
        userEmail: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            show: false
        }
    }
}
</script>
